import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration'; // CHANGED IMPORT
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// ✅ CHANGE THIS TO REGISTER
// This enables caching of assets (images, css, js) for faster loads
serviceWorkerRegistration.register();

reportWebVitals();